import { forwardRef, useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';

import Context from './BoundModalContext';

const BoundModalProvider = forwardRef<HTMLDivElement, React.HTMLProps<HTMLDivElement>>(
    ({ className, children, ...props }, ref) => {
        const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null);
        const classes = useStyles();

        return (
            <Context.Provider value={anchorEl}>
                <div
                    {...props}
                    className={clsx(classes.anchor, className)}
                    ref={node => {
                        setAnchorEl(node);
                        if (ref) {
                            if (typeof ref === 'function') {
                                ref(node);
                            } else {
                                ref.current = node;
                            }
                        }
                    }}
                >
                    {children}
                </div>
            </Context.Provider>
        );
    }
);
BoundModalProvider.displayName = 'BoundModalProvider';

const useStyles = makeStyles(
    {
        anchor: {
            position: 'relative',
            height: '100%',
        },
    },
    { classNamePrefix: 'bound-modal' }
);

export default BoundModalProvider;
